import { AppConfiguration } from "../app-configuration";
export class AtecoConfiguration {
// ATECO
public static ricercaAteco = AppConfiguration.SECURED + '/api/ateco/ricercaAteco/';
public static getElencoAteco = AppConfiguration.SECURED + '/api/ateco/getElencoAteco/';

public static ricercaAtecoByIdProfilo = AppConfiguration.SECURED + '/api/ateco/ricercaAtecoByIdProfilo/';
public static salvaAtecoByIdProfilo = AppConfiguration.SECURED + '/api/ateco/salvaAtecoByIdProfilo/';
public static eliminaAtecoByIdProfilo = AppConfiguration.SECURED + '/api/ateco/eliminaAtecoByIdProfilo/';
public static ricercaAtecoByIdCompetenza = AppConfiguration.SECURED + '/api/ateco/ricercaAtecoByIdCompetenza/';
public static salvaAtecoByIdCompetenza = AppConfiguration.SECURED + '/api/ateco/salvaAtecoByIdCompetenza/';
public static eliminaAtecoByIdCompetenza = AppConfiguration.SECURED + '/api/ateco/eliminaAtecoByIdCompetenza/';
public static getCodiciAtecoByIdProposta = AppConfiguration.SECURED + '/api/getCodiciAtecoByIdProposta/';
public static getCodiciAtecoByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciAtecoByIdCompetenza/';
}